import printJS from "print-js";
const { default: apiService } = require("apiService");
const BlobPrint = async (url) => {
  const res = await apiService.getblob(url);
  if (res) {
    const file = new Blob([res], { type: "application/pdf" });
    //Build a URL from the file
    const fileURL = URL.createObjectURL(file);
    //print blob
    // printJS(fileURL);
    const iframe = document.createElement("iframe"); //load content in an iframe to print later
    document.body.appendChild(iframe);

    iframe.style.display = "none";
    iframe.src = fileURL;
    iframe.onload = function () {
      setTimeout(function () {
        iframe.focus();
        iframe.contentWindow.print();
      }, 1);
    };
  }
};

export default BlobPrint;
